import type { BottomTabBarProps } from "@react-navigation/bottom-tabs";
import { CommonActions } from "@react-navigation/native";

import { TabButton } from "@/ui/core";
import type { FAIconName } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

type IconMap = Record<string, FAIconName>;

const createWebTabBar = (iconMap: IconMap) => {
  const WebTabBar = ({ descriptors, navigation, state }: BottomTabBarProps) => {
    return (
      <Box
        alignItems="center"
        backgroundColor={ColorToken.NeutralBackgroundPrimary}
        flexDirection="row"
        gap={24}
        justifyContent="center"
        paddingVertical={8}
        position="relative"
        style={{ boxShadow: "0 4px 24px 0 rgba(0, 0, 0, 0.08)" }}
        zIndex={1}
      >
        {state.routes.map((route) => {
          const index = state.routes.indexOf(route);
          const { options } = descriptors[route.key];
          const isFocused = state.index === index;

          const isHidden =
            options.tabBarItemStyle &&
            "display" in options.tabBarItemStyle &&
            options.tabBarItemStyle.display === "none";
          if (isHidden) {
            return null;
          }

          const handlePress = () => {
            const event = navigation.emit({
              canPreventDefault: true,
              target: route.key,
              type: "tabPress",
            });

            if (!isFocused && !event.defaultPrevented) {
              navigation.dispatch({
                ...CommonActions.navigate(route),
                target: state.key,
              });
            }
          };

          const badgeCount =
            typeof options.tabBarBadge === "number"
              ? options.tabBarBadge
              : undefined;

          return (
            <TabButton
              badgeCount={badgeCount}
              icon={iconMap[route.name]}
              isActive={isFocused}
              key={route.key}
              onPress={handlePress}
              testID={route.name}
              title={options.title ?? route.name}
            />
          );
        })}
      </Box>
    );
  };

  return WebTabBar;
};

export default createWebTabBar;
